// extracted by mini-css-extract-plugin
module.exports = {"spotClusterMarker":"SpotClusterMarker_spotClusterMarker__5LVWa"};